import React, { useEffect, useState } from "react";
import { formatDate, getAge, getUserName } from "../../Helpers/Utils/Common";
import dayjs from "dayjs";
import { Col, Row, Image, Space, Divider } from "antd";
import logo from "../../Assets/Images/clinica-prime-logo-dark.png"
import BarcodeSVG from "../BarcodeSVG/BarcodeSVG";
import "../../index.css";

const RoutingSlip = ({
  customerDetail,
  allBooking,
  bookingData,
  transactionNo,
  queueNo,
  pageSize = "A4",
}) => {
  const encoderName = getUserName();
  const [allDiagnosis, setAllDiagnosis] = useState([]);
  const [data, setData] = useState({});

  // Resolve queue number robustly from props and bookingData
  const resolvedQueueNo =
    queueNo ||
    bookingData?.data?.queue_no ||
    bookingData?.queue_no ||
    bookingData?.emr_queue_no ||
    bookingData?.emr_response?.queue_no ||
    bookingData?.emr_response?.queue_number ||
    "";

  // Resolve doctor name robustly
  const topLevelDoctor = 
    bookingData?.doctor_name || 
    bookingData?.data?.doctor_name || 
    bookingData?.data?.data?.doctor_name || 
    "";

  useEffect(() => {
    const bookings = bookingData?.bookings || bookingData?.data?.bookings || [];
    const patientMembership = bookingData?.patient_membership || bookingData?.data?.patient_membership;

    let all_data =
      allBooking?.filter(
        (item) =>
          item.details_type === "diagnosis" ||
          item.details_type === "consultation" ||
          item.details_type === "membership" ||
          item.details_type === "pharmacy" ||
          item.details_type === "lab-supply" ||
          item.details_type === "giftcheck"
      ) || [];

    // If all_data is empty but we have a valid booking context (e.g. just created a booking)
    // Synthesize a hardcoded Consultation row as requested
    if (all_data.length === 0 && topLevelDoctor) {
      const assessmentType = bookingData?.data?.assessment_type || bookingData?.assessment_type || localStorage.getItem("booking_assessment_type") || "";
      const transactionType = localStorage.getItem("booking_transaction_type") || "consultation";
      all_data = [{
        details_type: "consultation",
        transaction_type: transactionType,
        assessment_type: assessmentType,
        doctor_name: topLevelDoctor
      }];
    }

    all_data.forEach((item) => {
      if (item.details_type === "pharmacy" && item.medicine) {
        item.booking_name = item.medicine;
        item.lab_test = item.medicine;
      }
      if (item.details_type === "giftcheck" && item.name) {
        item.booking_name = item.name;
        item.lab_test = item.name;
      }
    });


    const booking_data =
      bookings?.filter(
        (item) =>
          item.transaction_type === "diagnosis" ||
          item.transaction_type === "consultation" ||
          item.transaction_type === "membership" ||
          item.transaction_type === "pharmacy" ||
          item.transaction_type === "giftcheck"
      ) || [];

    const activeData =
      booking_data.length > 0
        ? { 
            ...booking_data[0], 
            doctor_name: booking_data[0].doctor_name || topLevelDoctor 
          }
        : {
            doctor_name: topLevelDoctor,
            company_name:
              bookingData?.company_name ||
              bookingData?.data?.company_name ||
              bookingData?.data?.data?.company_name ||
              "",
          };

    setData({ ...activeData, patient_membership: patientMembership });
    
    // Ensure all_data items have doctor_name if missing
    const enriched_all_data = all_data.map(item => ({
      ...item,
      doctor_name: item.doctor_name || topLevelDoctor
    }));

    setAllDiagnosis(enriched_all_data);
  }, [bookingData, allBooking]);

  const customerName = `${customerDetail?.last_name || ""}, ${
    customerDetail?.first_name || ""
  } ${customerDetail?.middle_name || ""}`.trim();

  const containerWidth = pageSize === "A5" ? "148mm" : "210mm";
  const barcodeValue = String(
    transactionNo ||
    resolvedQueueNo ||
    customerDetail?.id ||
    ""
  );

  return (
    <div
      className="print-container"
      style={{
        width: containerWidth,
        minWidth: containerWidth,
        minHeight: "100%",
        background: "#fff",
        margin: "0 auto",
        padding: "0",
        boxSizing: "border-box",
        overflow: "visible",
      }}
    >
      <div style={{ padding: "3mm 5mm", width: "100%", boxSizing: "border-box" }}>
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          <div style={{ width: "60%" }}>
            <img
              width="130px"
              src={logo}
              alt="logo"
              style={{ marginBottom: "2px" }}
            />
            <div
              style={{
                fontSize: "9pt",
                fontWeight: "bold",
                marginTop: "2px",
                textTransform: "uppercase",
                width: "100%",
                lineHeight: "1.1",
              }}
            >
              {window.branch_address1 ||
                "2F OAKRIDGE IT CENTER 1, OAKRIDGE BUSINESS PARK, AS FORTUNA ST., BANILAD, MANDAUE CITY"}
            </div>
            <div style={{ fontSize: "9pt", marginTop: "1px" }}>
              {dayjs().format("MMM DD, YYYY hh:mm A")}
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              width: "40%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minHeight: "80px",
            }}
          >
            <div style={{ width: "100%", textAlign: "center" }}>
              {barcodeValue && (
                <BarcodeSVG
                  value={barcodeValue}
                  displayValue={true}
                  height={50}
                  width={1.8}
                  fontSize={20}
                />
              )}
            </div>
          </div>
        </div>

        {/* TITLE */}
        <div
          style={{
            textAlign: "center",
            fontSize: "18pt",
            fontWeight: "bold",
            margin: "5px 0",
            letterSpacing: "5px",
            whiteSpace: "nowrap",
            width: "100%",
          }}
        >
          R O U T I N G S L I P
        </div>

        {/* PATIENT INFO */}
        <div style={{ fontSize: "10pt", lineHeight: "1.4", width: "100%" }}>
          <div style={{ display: "flex", width: "100%", marginBottom: "2px" }}>
            <div style={{ width: "65%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "105px",
                  display: "inline-block",
                }}
              >
                Patient Name :
              </span>
              <span style={{ textTransform: "uppercase" }}>{customerName}</span>
            </div>
            <div style={{ width: "35%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "100px",
                  display: "inline-block",
                }}
              >
                Patient No :
              </span>
              <span>{customerDetail?.id || ""}</span>
            </div>
          </div>

          <div style={{ display: "flex", width: "100%", marginBottom: "2px" }}>
            <div style={{ width: "30%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "85px",
                  display: "inline-block",
                }}
              >
                Birthdate :
              </span>
              <span>{formatDate(customerDetail?.birthdate)}</span>
            </div>
            <div style={{ width: "12%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "40px",
                  display: "inline-block",
                }}
              >
                Age :
              </span>
              <span>{getAge(customerDetail?.birthdate)}</span>
            </div>
            <div style={{ width: "23%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "40px",
                  display: "inline-block",
                }}
              >
                Sex :
              </span>
              <span style={{ textTransform: "uppercase" }}>
                {customerDetail?.sex || ""}
              </span>
            </div>
            <div style={{ width: "35%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "70px",
                  display: "inline-block",
                }}
              >
                Encoder :
              </span>
              <span>{encoderName}</span>
            </div>
          </div>

          <div style={{ display: "flex", width: "100%", marginBottom: "2px" }}>
            <div style={{ width: "65%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "105px",
                  display: "inline-block",
                }}
              >
                Address :
              </span>
              <span style={{ textTransform: "uppercase" }}>{`${
                customerDetail?.street ?? ""
              }, ${customerDetail?.barangay ?? ""}, ${
                customerDetail?.city ?? ""
              }, ${customerDetail?.province ?? ""}`}</span>
            </div>
            <div style={{ width: "35%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "100px",
                  display: "inline-block",
                }}
              >
                Contact :
              </span>
              <span>{customerDetail?.contact_no || ""}</span>
            </div>
          </div>

          <div style={{ display: "flex", width: "100%", marginBottom: "2px" }}>
            <div style={{ width: "65%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "105px",
                  display: "inline-block",
                }}
              >
                Company :
              </span>
              <span>{data?.company_name || ""}</span>
            </div>
            <div style={{ width: "35%" }}>
              <span
                style={{
                  fontWeight: "bold",
                  width: "100px",
                  display: "inline-block",
                }}
              >
                Physician :
              </span>
              <span>{data?.doctor_name || topLevelDoctor || ""}</span>
            </div>
          </div>
        </div>

        <div style={{ borderTop: "0.5pt dotted #212020ff", margin: "8px 0" }}></div>

        {/* TABLE */}
        <div style={{ width: "100%", fontSize: "10pt" }}>
          <div
            style={{
              display: "flex",
              // fontWeight: "bold",
              borderBottom: "0.5pt dotted #212020ff",
              paddingBottom: "4px",
            }}
          >
            <div style={{ width: "15%", fontWeight: "bold", textAlign: "left" }}>Queue No.</div>
            <div style={{ width: "45%", fontWeight: "bold", textAlign: "left", paddingLeft: "70px" }}>
              Package / Exam Name
            </div>
            <div style={{ width: "20%", fontWeight: "bold", textAlign: "center" }}>Remarks</div>
            <div style={{ width: "20%", fontWeight: "bold", textAlign: "center" }}>Verified By</div>
          </div>

          {/* TABLE CONTENT */}
          <div style={{ minHeight: "75px" }}>
            {allDiagnosis.map((arr, idx) => {
              const maskSensitiveName = (name) => {
                return String(name || "")
                  .replace(/hiv/gi, "IMMUNO COMPROMISED HOST")
                  .replace(/gonorrhea/gi, "URITHRITIS");
              };

              const queueNoToDisplay =
                arr.details_type !== "lab-supply" &&
                arr.details_type !== "giftcheck" &&
                arr.details_type !== "membership"
                  ? resolvedQueueNo ?? arr.queue_no ?? ""
                  : "";

              // User requested logic for consultation
              const isConsultation =
                arr.details_type === "consultation" ||
                arr.transaction_type === "consultation";

              // Build display name for consultation: merge assessment_type and transaction_type
              const consultationDisplayName = () => {
                const assessmentType = arr.assessment_type ||
                  bookingData?.data?.assessment_type ||
                  bookingData?.assessment_type ||
                  localStorage.getItem("booking_assessment_type") ||
                  "";
                const transactionType = arr.transaction_type ||
                  localStorage.getItem("booking_transaction_type") ||
                  "";

                if (assessmentType && transactionType) {
                  return `${assessmentType}-${transactionType}`;
                } else if (assessmentType) {
                  return assessmentType;
                } else if (transactionType) {
                  return transactionType.charAt(0).toUpperCase() + transactionType.slice(1);
                }
                return "Consultation";
              };

              const displayName = isConsultation
                ? consultationDisplayName()
                : maskSensitiveName(
                    arr.lab_test || arr.booking_name || arr.package
                  );
              const verifiedBy = isConsultation
                ? arr.doctor_name || data?.doctor_name || ""
                : "";

              if (arr.type === "package" && !isConsultation) {
                const tests = arr.lab_test.split("");
                return (
                  <div key={idx}>
                    <div
                      style={{
                        display: "flex",
                        padding: "6px 0",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "15%", fontWeight: "bold", textAlign: "left" }}>
                        {queueNoToDisplay}
                      </div>
                      <div
                        style={{
                          width: "45%",
                          textAlign: "left",
                          paddingLeft: "70px",
                        }}
                      >
                        {maskSensitiveName(arr.package)}
                      </div>
                      <div style={{ width: "20%" }}></div>
                      <div style={{ width: "20%" }}></div>
                    </div>
                    {tests.map((test, tIdx) => (
                      <div
                        key={tIdx}
                        style={{
                          display: "flex",
                          padding: "3px 0",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: "15%" }}></div>
                        <div
                          style={{
                            width: "45%",
                            textAlign: "left",
                            paddingLeft: "15px",
                          }}
                        >
                          - {maskSensitiveName(test.split("|")[1])}
                        </div>
                        <div style={{ width: "20%", padding: "0 10px" }}>
                          <div
                            style={{ borderBottom: "1px solid #000", height: "14px" }}
                          ></div>
                        </div>
                        <div style={{ width: "20%", padding: "0 10px" }}>
                          <div
                            style={{ borderBottom: "1px solid #000", height: "14px" }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              }

              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    padding: "6px 0",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "15%", fontWeight: "bold", textAlign: "left" }}>
                    {queueNoToDisplay}
                  </div>
                  <div
                    style={{
                      width: "45%",
                      textAlign: "left",
                      paddingLeft: "70px",
                    }}
                  >
                    {displayName}
                  </div>
                  <div style={{ width: "20%", padding: "0 10px" }}>
                    <div
                      style={{ borderBottom: "1px solid #000", height: "14px" }}
                    ></div>
                  </div>
                  <div
                    style={{
                      width: "20%",
                      padding: "0 10px",
                      textAlign: "center",
                      fontSize: "9pt",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid #000",
                        height: "14px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {verifiedBy}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ borderTop: "0.5pt dotted #212020ff", margin: "10px 0" }}></div>

        {/* FOOTER */}
        <div style={{ fontSize: "10pt", width: "100%", marginTop: "15px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <div style={{ width: "55%" }}>
              <div
                style={{
                  display: "flex",
                  marginBottom: "8px",
                  width: "100%",
                  alignItems: "flex-end",
                }}
              >
                <span style={{ fontWeight: "bold", width: "85px" }}>
                  Remarks :
                </span>
                <div
                  style={{
                    flex: 1,
                    textTransform: "uppercase",
                    paddingLeft: "5px",
                    fontWeight: "bold",
                    fontSize: "9pt",
                  }}
                >
                </div>
              </div>
              <div style={{ display: "flex", marginBottom: "15px", width: "100%" }}>
                <span style={{ fontWeight: "bold", width: "85px" }}>
                  Results To :
                </span>
                <div style={{ flex: 1 }}></div>
              </div>
            </div>

            <div style={{ width: "40%", textAlign: "center", marginTop: "5px" }}>
              <div
                style={{
                  borderBottom: "1pt solid #000",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  padding: "0 10px",
                  marginBottom: "2px",
                  fontSize: "9pt",
                }}
              >
                {customerName}
              </div>
              <div style={{ fontSize: "9pt" }}>
                Signature over printed name
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "30px",
              fontStyle: "italic",
              width: "100%",
              fontSize: "9pt",
            }}
          >
            *** Nothing Follows ***
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoutingSlip;

